<div class="LoginPageMain">
    <div class="appLogo MobileShow">
        <img [src]="userLogo">
    </div>
    <div class="AlignCenter">
        <div class="loginBox">
            <!-- Carousel Section -->
            <div class="box boxLeft">
                <div class="UpdatesText" *ngIf="notClosed">
                    <h3>Lorem Ipsum is simply dummy texts of the printing</h3>
                    <p>Orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type Changed.</p>
                    <a class="btn">Learn More</a>
                    <button class="CloseIcon" (click)="closeMessageBox()">
                        <i class="fa-solid fa-circle-xmark"></i>
                    </button>
                </div>
                <app-showcase-carousel class="SliderBox"></app-showcase-carousel>
            </div>
            
            <!-- Forms Section -->
            <div class="box boxRight" [ngClass]="{'mfa-active': currentForm === 'MFA'}">
                <div class="boxRightContent">
                    <div class="appLogo MobileHide">
                        <img [src]="userLogo">
                    </div>
                    <div class="FormContainer">
                        <div class="FormHeading">{{ currentFormHeading | translate }}</div>
                        <div class="greyCapsuleMain"><p class="greyCapsule" *ngIf="accessCode">Access Code: {{ accessCode.toUpperCase() }}</p></div>

                        <app-form-notification *ngIf="notificationShown" [type]="notificationType" (close)="showNotificationFor(null)"></app-form-notification>

                        <div class="FormBox relative">
                            <ng-container [ngSwitch]="currentForm">
                                <app-access-code-form
                                    *ngSwitchCase="'ACCESSCODE'"
                                    [lastFormTracker]="lastForm$"
                                    (notify)="showNotificationFor($event)"
                                    (result)="updateData($event)">
                                </app-access-code-form>

                                <app-login-form
                                  #loginForm
                                    *ngSwitchCase="'LOGIN'"
                                    [lastFormTracker]="lastForm$"
                                    [accessCode]="accessCode"
                                    (formChange)="toggleToForm($event)"
                                    (notify)="showNotificationFor($event)"
                                    >
                                </app-login-form>

                                <app-password-recovery-form
                                    *ngSwitchCase="'RECOVERY'"
                                    [accessCode]="accessCode"
                                    (formChange)="toggleToForm($event)"
                                    (notify)="showNotificationFor($event)"> 
                                </app-password-recovery-form>

                                 <app-forgot-userid 
                                 [accessCode]="accessCode"
                                 (formChange)="toggleToForm($event)"
                                    (notify)="showNotificationFor($event)"
                                  *ngSwitchCase="'FORGOTUSERID'">
                                </app-forgot-userid>

                                <p *ngSwitchDefault>Sorry, Something went wrong there!</p>
                            </ng-container>
                        </div>
                        <div class="BackLoginPage" *ngIf="currentForm === 'RECOVERY' || currentForm === 'LOGIN' || currentForm === 'FORGOTUSERID'">
                            <button id="btlBackToLogin" (click)="toggleToPreviousForm()">{{ 'page.login.backButton' | translate }}</button>
                        </div>
                        <!-- <button mat-button (click)="openDialog()">Open dialog</button> -->
                    </div>
                </div>
                <div class="devText">
                    <div class="versionAndPoweredBy">
                        <div class="poweredbylogo">
                            <span class="TitleText">Powered By</span>
                            <img src="../../../assets/images/PoweredByXeople.png" class="PoweredByLogoImg">
                        </div>
                        <div class="versionInfo">{{"page.login.version"|translate}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
